import React from 'react'
import { BetterComponent } from '../../../better-component/better-component'
import { IRule, IRuleDefinition } from '../../interfaces/rule'
import { Select } from 'antd'
import autobind from 'autobind-decorator'
import { IRuleValidationResponse } from '../../interfaces/rule-validation-response'

interface IBooleanInputProps {
    rule: IRule
    onChange: (value: boolean) => any
}

export class BooleanInput extends BetterComponent<IBooleanInputProps, {}> {
    public readonly defaultClassName = 'sw-v2-rb-boolean-input'
    public ref: any

    public render(): React.ReactNode {
        return (
            <Select
                ref={(el) => (this.ref = el)}
                className={this.buildRootClassNames()}
                dropdownClassName={this.buildClassName('dropdown')}
                onChange={this.handleChange}
                value={this.valueAsString}
            >
                <Select.Option value="true">TRUE</Select.Option>
                <Select.Option value="false">FALSE</Select.Option>
            </Select>
        )
    }

    public validate(): IRuleValidationResponse {
        const response: IRuleValidationResponse = { ok: true }
        return response
    }

    protected get rule(): IRuleDefinition {
        return this.props.rule.rule
    }

    protected get valueAsString(): string {
        return this.rule.value === undefined ? 'true' : String(this.rule.value.toString() === 'true')
    }

    @autobind
    protected async handleChange(value: string): Promise<void> {
        this.props.onChange(value === 'true')
    }

    protected buildClassName(className: string): string {
        return `${this.defaultClassName}-${className}`
    }

    protected buildRootClassNames(): string {
        const classNames: string[] = [this.defaultClassName]

        return classNames.join(' ')
    }
}
